import { forwardRef } from 'react';

import type { TextFieldProps } from '../components/ui/text-field/textarea-field';
import { TextAreaField } from '../components/ui/text-field/textarea-field';
import { useFieldContext, useFormContext } from './use-form.context';

type FormTextAreaFieldProps = TextFieldProps & {};

export const FormTextAreaField = forwardRef<
  HTMLTextAreaElement,
  FormTextAreaFieldProps
>((props, ref) => {
  const form = useFormContext();
  const field = useFieldContext<string>();

  const isBlurred = field.state.meta.isBlurred;
  const isFormSubmitted = field.form.state.submissionAttempts > 0;
  const isFieldWithErrors = field.state.meta.errors.length > 0;

  return (
    <form.Subscribe selector={(state) => [state.isSubmitting]}>
      {([isSubmitting]) => (
        <TextAreaField
          ref={ref}
          {...props}
          error={field.state.meta.errors[0]?.message}
          disabled={isSubmitting}
          value={field.state.value}
          onChange={(e) => field.handleChange(e.target.value)}
          onBlur={field.handleBlur}
          hasError={(isBlurred || isFormSubmitted) && isFieldWithErrors}
        />
      )}
    </form.Subscribe>
  );
});
FormTextAreaField.displayName = 'FormTextField';
